import { defineMessage, type IntlShape, type MessageDescriptor } from 'react-intl';
import type { ActivityType } from '@alltrails/types/ActivityType';

const messages: Record<ActivityType, MessageDescriptor> = {
  backpacking: defineMessage({ defaultMessage: 'Backpacking' }),
  'bike-touring': defineMessage({ defaultMessage: 'Bike touring' }),
  birding: defineMessage({ defaultMessage: 'Birding' }),
  camping: defineMessage({ defaultMessage: 'Camping' }),
  'cross-country-skiing': defineMessage({ defaultMessage: 'Cross-country skiing' }),
  fishing: defineMessage({ defaultMessage: 'Fishing' }),
  hiking: defineMessage({ defaultMessage: 'Hiking' }),
  'horseback-riding': defineMessage({ defaultMessage: 'Horseback riding' }),
  'mountain-biking': defineMessage({ defaultMessage: 'Mountain biking' }),
  'nature-trips': defineMessage({ defaultMessage: 'Nature trips' }),
  'off-road-driving': defineMessage({ defaultMessage: 'Off-road driving' }),
  'paddle-sports': defineMessage({ defaultMessage: 'Paddle sports' }),
  'road-biking': defineMessage({ defaultMessage: 'Road biking' }),
  'rock-climbing': defineMessage({ defaultMessage: 'Rock climbing' }),
  running: defineMessage({ defaultMessage: 'Running' }),
  'scenic-driving': defineMessage({ defaultMessage: 'Scenic driving' }),
  skiing: defineMessage({ defaultMessage: 'Skiing' }),
  snowshoeing: defineMessage({ defaultMessage: 'Snowshoeing' }),
  'trail-running': defineMessage({ defaultMessage: 'Trail running' }),
  'via-ferrata': defineMessage({ defaultMessage: 'Via ferrata' }),
  walking: defineMessage({ defaultMessage: 'Walking' })
};

const getActivityType = (intl: IntlShape, activityType: ActivityType) =>
  Object.keys(messages).includes(activityType) ? intl.formatMessage(messages[activityType]) : '';

export default getActivityType;
